import uniqid from 'uniqid';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { get, cloneDeep } from '@/helpers';

import { moneyFormat } from '@/filters';

import Error from '@/components/Error';
import FullImage from '@/extensions/shop/components/LazyCategoryProducts/Partials/FullImage';
import PreviewImage from '@/extensions/shop/components/LazyCategoryProducts/Partials/PreviewImage';
import ProductProperty from '@/extensions/shop/components/ProductProperty';
import Preorder from '@/extensions/shop/components/LazyCategoryProducts/Partials/Preorder.vue';

export default {
    data: () => ({
        m: 0, // active media key
        mediaWidth: undefined,
        selectedOptions: {}, // key is property id
        qty: 1
    }),
    components: {
        Error,
        FullImage,
        PreviewImage,
        ProductProperty,
        Preorder
    },
    watch: {
        qty(value) {
            if (value < 1) this.qty = 1;
            else if (value > this.maxQty) this.qty = this.maxQty;
        }
    },
    computed: {
        nr() {
            return this.product.nr;
        },
        name() {
            let name = this.product.name;

            if (this.validArticles && this.validArticles.length && this.validArticles[0].name) {
                name = this.validArticles[0].name;
            }

            return name;
        },
        description() {
            // let description = get(this.product, 'description');
            let description = '';
            description =
                this.properties.find(property => property.label === 'Ausführliche Beschreibung') ||
                get(this.product, 'description') ||
                '';
            if (description && description.options && description.options[0] && description.options[0].value) {
                description = description.options[0].value;
            } else description = '';
            // if (!description) description = this.productProperties.find(el => el.key === 'buchinfo');
            // if (!description) description = '';
            // if (typeof description == 'object') return description.value;

            // if (this.validArticles && this.validArticles.length && this.validArticles[0].description)
            //     description = this.validArticles[0].description;
            return description;
        },
        media() {
            let media = this.product.media;
            if (media != null && media.id) media = [media];

            if (
                this.validPropertySelection &&
                this.validArticles &&
                this.validArticles.length &&
                this.validArticles[0].media &&
                this.validArticles[0].media.length
            )
                media = this.validArticles[0].media;

            if (media && media.length) {
                media = media.filter(el => {
                    return get(el, 'settings.show.detail', true) === true;
                });
            } else {
                media = [];
            }

            return media;
        },
        properties() {
            let properties = [];

            const normalizePropertyOptions = el => {
                const propType = el.property.propType;
                let options = el.values.map(el => {
                    const key = propType.value_field;
                    const value = get(el, key);

                    let valueAlt;
                    const keyAlt = propType.value_field_alt;
                    if (keyAlt) valueAlt = get(el, keyAlt);

                    return {
                        id: el.id,
                        image: el.image,
                        value,
                        valueAlt,
                        key
                    };
                });
                return options;
            };

            if (this.product.propertyPivots && this.product.propertyPivots.length) {
                this.product.propertyPivots.forEach(el => {
                    const id = el.property.id;
                    const key = el.property.key;
                    const label = el.property.name;
                    const visible = el.property.visible_on_product_listing || el.property.visible_on_detail_page;
                    const type = el.property.propType.key;

                    // const propType = el.property.propType;
                    const articleRequired = el.property.article_required;

                    // let key = el.key
                    const options = normalizePropertyOptions(el);
                    let property = {
                        id,
                        key,
                        type,
                        label,
                        options,
                        articleRequired,
                        visible
                    };

                    // if (el.key.toLowerCase() === 'länge') {
                    //   property.label = 'length';
                    // }
                    properties.push(property);
                });
            }

            return properties.filter(property => {
                return property.visible !== false || property.options.length > 1;
            });
        },
        valid() {
            // check if this product is valid
            // by required stuff is missing
            // - price
            // ...
            return !!this.product.price;
        },
        // price() {
        //     if (!this.product.price) return null;
        //     return this.getPrice();
        // },
        // salePrice() {
        //     if (!this.product.salePrice) return null;
        //     return this.getPrice('salePrice');
        // },
        taxRate() {
            if (!this.product.price) return null;

            let string = this.product.price.tax.value.toString() + '%';

            // get all prices from related articles
            // define range

            let range = {
                from: this.product.price.tax.value,
                to: this.product.price.tax.value
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    if (article.price) {
                        range.from = Math.min(range.from, article.price.tax.value);
                        range.to = Math.max(range.from, article.price.tax.value);
                    }
                });

                if (range.from < range.to) {
                    string = `${range.from}% - ${range.to}%`;
                }
            }

            return string;
        },
        price() {
            if (!this.product.price) return null;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            let key = 'value';
            if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

            // return moneyFormat(price.value - tax, code);
            let string = moneyFormat(this.product.price[key], code);

            // get all prices from related articles
            // define range

            let range = {
                from: this.product.price[key],
                to: this.product.price[key]
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    if (article.price) {
                        range.from = Math.min(range.from, article.price[key]);
                        range.to = Math.max(range.from, article.price[key]);
                    }
                });

                if (range.from < range.to) {
                    string = 'ab ' + moneyFormat(range.from, code);
                    // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                }
            }

            return string;
        },
        salePrice() {
            if (!this.product.salePrice) return null;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            let key = 'value';
            if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

            // return moneyFormat(salePrice.value - tax, code);
            let string = moneyFormat(this.product.salePrice[key], code);

            // get all sale prices from related articles
            // define range

            let range = {
                from: this.product.salePrice[key],
                to: this.product.salePrice[key]
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    if (article.salePrice) {
                        range.from = Math.min(range.from, article.salePrice[key]);
                        range.to = Math.max(range.from, article.salePrice[key]);
                    }
                });

                if (range.from < range.to) {
                    string = 'ab ' + moneyFormat(range.from, code);
                    // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                }
            }

            return string;
        },
        priceRange() {
            if (!this.product.price) return null;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            let key = 'value';
            if (this.customer && get(this.customer, 'show_net_prices')) key = 'net_value';

            let string;

            // get all prices from related articles
            // define range

            let price = this.product.salePrice?.[key] || this.product.price?.[key];

            let range = {
                from: price,
                to: price
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    const articlePrice = article?.salePrice || article?.price;
                    if (articlePrice) {
                        range.from = Math.min(range.from, articlePrice[key]);
                        range.to = Math.max(range.to, articlePrice[key]);
                    }
                });

                if (range.from < range.to) {
                    // string = 'ab ' + moneyFormat(range.from, code);
                    string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
                }
            }

            return string;
        },
        maxQty() {
            let maxQty = Infinity;
            if (this.validArticles && this.validArticles.length === 1 && this.validArticles[0].qty_sum !== null)
                maxQty = this.validArticles[0].qty_sum;
            return maxQty;
        },
        activeMedia() {
            const m = Math.min(this.media.length - 1, this.m);
            return this.media[m];
        },
        visibleProperties() {
            return this.properties.filter(property => {
                return (
                    property.visible !== false || property.options.length > 1
                    // || (property.options.length === 1 && property.options[0].value !== this.description)
                );
            });
        },
        articleProperties() {
            return this.visibleProperties.filter(property => {
                return property.articleRequired;
            });
        },
        configurableArticleProperties() {
            return this.properties.filter(property => {
                return property.options && property.options.length > 1 && property.articleRequired;
            });
        },
        configurableProductProperties() {
            return this.properties.filter(property => {
                return property.options && property.options.length > 1 && property.articleRequired === false;
            });
        },
        nonConfigurableProperties() {
            return this.properties.filter(property => property.options && property.options.length <= 1);
        },
        validPropertySelection() {
            let valid = false;
            const pendingProperties = this.properties.filter(property => {
                return property.options.length > 1 && !this.selectedOptions[property.id];
            });
            if (!pendingProperties.length) valid = true;
            return valid;
        },
        sellableArticles() {
            let articles = this.product.articles;

            // pay attention to stock
            const manageStock = this.product.manage_stock;
            if (manageStock && this.product.articles && this.product.articles.length) {
                articles = this.product.articles.filter(article => article.qty_sum > 0);
            }

            return articles;
        },
        validArticles() {
            let articles = this.sellableArticles;
            if (this.sellableArticles && this.sellableArticles.length) {
                articles = this.sellableArticles.filter(article => {
                    let match = true;

                    // check qty in cart
                    // qty in cart must be smaller
                    // than article.qty_sum (if manageStock)
                    if (this.product.manage_stock) {
                        let cartQty = 0;
                        this.cart.articlePivots.forEach(articlePivot => {
                            if (articlePivot.article.id === article.id) cartQty += articlePivot.qty;
                        });
                        if (article.qty_sum <= cartQty) match = false;
                    }
                    // all property pivots must match
                    if (match) {
                        article.propertyPivots.forEach(el => {
                            const property = el.property;
                            const value = el.value;
                            if (this.selectedOptions[property.id]) {
                                const option = this.selectedOptions[property.id];
                                if (value[option.key] !== option.value) match = false;
                            }
                        });
                    }
                    return match;
                });
            }
            return articles;
        },
        ...mapGetters({
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            defaultTax: 'shop/defaultTax',
            cart: 'shop/cart'
        })
    },
    methods: {
        // getPrice(key = 'price') {
        //     const code =
        //         get(this.customer, 'customerGroup.currency.iso4217') ||
        //         get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        //         'EUR';

        //     let string = moneyFormat(this.product[key].value, code);

        //     // get all prices from related articles
        //     // define range

        //     let range = {
        //         from: this.product[key].value,
        //         to: this.product[key].value
        //     };

        //     if (this.validArticles && this.validArticles.length) {
        //         this.validArticles.forEach(article => {
        //             if (article[key]) {
        //                 range.from = Math.min(range.from, article[key].value);
        //                 range.to = Math.max(range.from, article[key].value);
        //             }
        //         });

        //         if (range.from < range.to) {
        //             string = 'ab ' + moneyFormat(range.from, code);
        //             // string = moneyFormat(range.from, code) + ' - ' + moneyFormat(range.to, code);
        //         }
        //     }

        //     return string;
        // },
        calculateMediaWidth() {
            if (this.$refs.media) {
                const style = getComputedStyle(this.$refs.media);
                this.mediaWidth = Math.min(this.$refs.media.clientWidth, 300);
                this.mediaWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            }
        },
        selectMedia(m) {
            this.m = m;
        },
        toggleActiveArticle(article) {
            if (this.activeArticle && this.activeArticle.id === article.id) {
                this.activeArticle = undefined;
                this.leave();
            } else {
                this.activeArticle = article;
                this.focus('main');
            }
        },
        selectPropertyOption({ property, option }) {
            if (this.selectedOptions[property.id] && this.selectedOptions[property.id].id === option.id) {
                this.$delete(this.selectedOptions, property.id);
            } else {
                const value = { label: property.label, articleRequired: property.articleRequired, ...option };
                this.$set(this.selectedOptions, property.id, value);
                // check if there are validArticles
                // if not delete all selectedOptions
                // that are not available in combination
                // with the latest selection

                if (this.sellableArticles.length) {
                    let attempts = 0;
                    while (!this.validArticles.length && attempts < 1) {
                        ++attempts;
                        let match = false;
                        if (!match) {
                            this.properties.forEach(prop => {
                                if (
                                    prop.articleRequired &&
                                    prop.options.length &&
                                    this.selectedOptions[prop.id] &&
                                    prop.id !== property.id
                                ) {
                                    // find sellable article with selected options
                                    // without the current opt
                                    // if there are some, delete this prop from selectedOptions

                                    const articles = this.sellableArticles.filter(article => {
                                        // all property pivots must match
                                        let match = true;
                                        article.propertyPivots.forEach(el => {
                                            const property = el.property;
                                            const value = el.value;
                                            if (prop.id !== property.id && this.selectedOptions[property.id]) {
                                                const option = this.selectedOptions[property.id];
                                                if (value[option.key] !== option.value) match = false;
                                            }
                                        });
                                        return match;
                                    });

                                    if (articles.length) {
                                        this.$delete(this.selectedOptions, prop.id);
                                        match = true;
                                    }
                                }
                            });
                        }
                    }
                }
            }
        },
        addToCart() {
            if (!this.validArticles || this.validArticles.length > 1) {
                const errorMessage = {
                    id: uniqid(),
                    title: 'Fehler',
                    text:
                        'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    type: 'error',
                    autoclose: 8000
                };
                this.addMessage(errorMessage);
            } else {
                let article = this.validArticles[0];
                article.product = cloneDeep(this.product);
                delete article.product.articles;

                let productPropertyValues = [];
                Object.keys(this.selectedOptions).map(key => {
                    if (!this.selectedOptions[key].articleRequired)
                        productPropertyValues.push(this.selectedOptions[key].id);
                });

                this.addArticleToCart({ article, productPropertyValues, qty: parseInt(this.qty) });

                const properties = Object.keys(this.selectedOptions)
                    .map(key => `${this.selectedOptions[key].label}: ${this.selectedOptions[key].value}`)
                    .join('<br>');

                const text = `
                    <p>Der folgende Artikel wurde Ihrem Warenkorb hinzugefügt</p>
                    <blockquote class="mt-2 pl-3 border-l-2 border-white border-opacity-50">
                    <h4 class="text-xl leading-none mb-1">${this.name}</h4>
                    <p class="text-xs mb-2 text-white text-opacity-75">#${this.nr}</p>
                    <p>${properties}</p>
                    <p>Preis: ${this.price}</p>
                    </blockquote>
                `;

                const message = {
                    id: uniqid(),
                    text,
                    type: 'success',
                    autoclose: 4000
                };
                this.addMessage(message);

                this.selectedOptions = {};
                this.qty = 1;
            }
        },
        ...mapMutations({
            setProduct: 'shop/setProduct'
        }),
        ...mapActions({
            addMessage: 'message/add',
            addArticleToCart: 'shop/addArticleToCart',
            fetchProduct: 'shop/fetchProduct'
        })
    }
};
